<template>
  <div>
    <el-container style="overflow: hidden; min-width: 1600px;padding-left: 20px;padding-top: 15px;padding-right: 20px;">
      <div style="float: left; width: 20%; white-space: nowrap">
        <el-form inline @submit.native.prevent style="width:100%">
          <el-form-item label="出库单号" style="width:100%" class="outboundNoItem">
            <el-input
              style="width:100%"
              v-model.trim="outboundNo"
              placeholder="请扫描出库单号"
              clearable
              @keyup.enter.native="initTable"
              ref="outboundRef"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="buttonDiv" style="float: left; width: 30%;margin-left: 2%;">
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>

        <!-- <el-button type="primary" @click="initTable">查询</el-button> -->

        <!-- <el-button type="primary" @click="importExport">导入</el-button> -->
      </div>
    </el-container>

    <el-container>
      <el-main>
        <div>
          <!-- left sidebar -->
          <div class="left-item">
            <el-card class="box-card" style="width: 100%">
              <div slot="header" class="clearfix">
                <span>出库信息</span>
              </div>
              <div class="left-item-card">
                <div style="width: 99%">
                  <template v-if="shartSearch">
                    <el-card
                      class="box-card"
                      style="width: 100%; background-color: rgba(0, 0, 0, 0.1)"
                    >
                      <div
                        class="text item"
                        style="text-align: center; color: #909399"
                      >
                        <i class="el-icon-loading"></i>搜索中...
                      </div>
                    </el-card>
                  </template>
                  <template v-else>
                    <template>
                      <el-card
                        class="box-card"
                        style="
                          margin-bottom: 10px;
                          cursor: pointer;
                          width: 100%;
                          background-color: #c5c7cc;"
                      >
                        <div class="text item">
                          <div>发货单号：{{ OutboundInfo.outboundNo }}</div>
                          <div>参考单号：{{ OutboundInfo.orgOutboundNo }}</div>
                          <div>发货仓库：{{ OutboundInfo.warehouseName }}</div>
                          <div>出库状态：{{ OutboundInfo.outboundStatusText }}</div>
                          <div>预发箱数：{{ OutboundInfo.boxCount }}</div>
                          <div>已出库数：{{ OutboundInfo.sendBoxCount }}</div>
                        </div>
                      </el-card>
                      <el-table
                        border
                        :data="trayTableData"
                        style="width: 100%"
                        v-loading="shartSearch"
                      >
                        <el-table-column
                          prop="customerBox1"
                          label="托盘编号"
                          align="center"
                        >
                        <template slot-scope="scope">
                          <div>{{ scope.$index + 1 }}/{{ trayTableData.length }}</div>
                        </template>
                        </el-table-column>
                        <el-table-column
                          prop="storages"
                          label="库位"
                          align="center"
                        />
                        <el-table-column
                          prop="boxCount"
                          label="箱数"
                          align="center"
                        />
                      </el-table>
                    </template>
                  </template>
                </div>
              </div>
            </el-card>
          </div>

          <!-- right table -->
          <div
            style="float: left; margin-left: 2%; width: 74%"
            class="otherTable"
          >
            <div>
              <el-form ref="form" :inline="true">
                <el-row>
                  <el-col>
                     <el-form-item label="请扫描未发箱号" prop="resource">
                      <el-input
                      id="scanBox"
                      v-model.trim="scanBoxNo"
                      ref="scanBoxRef"
                      :disabled="scanBoxDisabled"
                      @keyup.enter.native="getTableList()"
                    ></el-input>
                    <span v-if="showNoMatch" class="noMatch">未匹配到箱号，请确认</span>
                    </el-form-item>
                    <el-form-item
                      label="库位"
                      class="noMarginBot"
                      prop="LocationCode"
                    >
                      <el-select
                        v-model="storages"
                        style="width: 100%"
                        placeholder="请选择库位"
                        multiple
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in OutboundInfo.locationList"
                          :label="item.locationCode"
                          :value="item.locationCode"
                          :key="item.locationCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                   
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <el-row type="flex" class="row-bg">
              <span class="errorMsg">
                {{ scanBoxCodeErrorMsg }}
              </span>
            </el-row>
            <span>未发货箱子列表:</span>
            <div class="all-clear">
              <el-table-bar :fixed="false" :bottom="35">
                <el-table
                  class="cancelFixedTop"
                  border
                  :data="tableData"
                  style="width: 100%"
                  v-loading="listLoading"
                  @selection-change="handleRowSelect"
                  @row-click="handleRowClick"
                  ref="multipleTable"
                >
                  <el-table-column
                    prop="customerBox"
                    label="箱号"
                    min-width="130"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="actualBoxWeight"
                    label="毛重(kg)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="actualBoxVolume"
                    label="体积(cbm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="actualBoxLength"
                    label="长(cm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="actualBoxWidth"
                    label="宽(cm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="actualBoxHeight"
                    label="高(cm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </el-table-bar>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    
  
  <el-dialog
      append-to-body
      title="完成装车"
      :visible.sync="showPhotoModel"
      @close="close"
      :center="true"
    >
      <div style="font-size: 15px; font-weight: 600; margin-bottom: 10px">
        出库{{ num1s || 0 }}箱，未出库{{ num2s || 0 }}箱。
      </div>
      <div class="demo-image">
        <ul v-for="(item, i) in photoList" :key="i">
          <div v-for="(item2, i2) in item" :key="i2" class="image-box">
            <p>
              <span style="color: red" v-if="item2.required">*</span
              >{{ item2.text }}
            </p>
            <div
              class="sign-photo-item"
              v-if="imgObj[item2.name]"
              @mouseover="imgMouseOver(i, i2)"
              @mouseleave="imgMouseLeave(i, i2)"
            >
              <div class="del-box" v-if="item2.showControl">
                <i
                  class="el-icon-zoom-in"
                  style="margin-right: 10px"
                  @click="showImg(imgObj[item2.name])"
                ></i>
                <i class="el-icon-delete" @click="deleteImg(item2.name)"></i>
              </div>
              <div class="loading-box" v-if="item2.loading">
                <i class="el-icon-loading"></i>
              </div>
              <img
                :src="imgObj[item2.name]"
                class="sign-photo-item-img"
                alt=""
              />
            </div>

            <div class="sign-photo-btn" v-else>
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg(i, i2)"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                />
                <p @click="chooseImage(item2.id)" class="photo-s">
                  <i class="el-icon-picture-outline"></i>
                </p>
              </div>
            </div>
          </div>
        </ul>

        <el-dialog
          :visible.sync="dialogVisible"
          width="60%"
          :modal="false"
          :center="true"
          append-to-body
          custom-class="imgPreview"
        >
          <img height="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确认装车</el-button>
        <el-button @click="showPhotoModel = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 上传发货信息 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传发货信息"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
              :auto-upload="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="submitUpload"
              >确认上传</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div style="color: red"> {{ Importtext }}</div>
        </el-row>
      </el-form>
    </el-dialog>

  </div>

</template>

<script>
import {
  getOutboundSendDetail,
  overSendSubmit,
  exportTFOutboundBox,
  importTFOutboundBox
} from "@/api/outbound/outboundOrder.js";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { thereAre } from "util/util";
import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
export default {
  components: { Toolbar },
  data() {
    return {
      trayTableData:[],
      scanBoxDisabled: false,
      scanBoxCodeErrorMsg:'',
      filters: {
        resource:"false"
      },
      showNoMatch: false,
      scanBoxNo: "",
      outboundNo:'',
      buttonList: [],
      shartSearch: false,
      listLoading: false,
      importVisible:false,
      progressFlag:false,
      tableData: [],
      OutboundInfo:{},
      isShowScanNoSend: false,
      showPhotoModel: false,
      Importtext: "", //导入返回信息
      saveImgUrlArr: [],
      storages: [],
      num1s: 0,
      num2s: 0,
      progressPercent:0,
      imgObj: {
        // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      },
      photoList: [
        [
          {
            name: "img1",
            text: "车牌照",
            id: 1,
            showControl: false,
            loading: false,
            required: true,
          },
          {
            name: "img2",
            text: "空柜照",
            id: 2,
            showControl: false,
            loading: false,
            required: true,
          },
          {
            name: "img3",
            text: "托运单",
            id: 3,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
        [
          {
            name: "img4",
            text: "未关门照",
            id: 4,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img5",
            text: "半关门照",
            id: 5,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img6",
            text: "关门照",
            id: 6,
            showControl: false,
            loading: false,
            required: true,
          },
        ],
        [
          {
            name: "img7",
            text: "锁封照",
            id: 7,
            showControl: false,
            loading: false,
            required: true,
          },
          {
            name: "img8",
            text: "其他",
            id: 8,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img9",
            text: "其他1",
            id: 9,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
      ],
      imgFiles: [],
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  methods: {
    getTableList() {
        
      //  选择
      this.$refs.scanBoxRef.select()
      this.scanBoxDisabled = true
      let flag = true;
      if(this.OutboundInfo.outboundNo===undefined)
      {
          this.showNoMatch = false;
          this.scanBoxDisabled = false
          this.$nextTick(()=>{
            this.$refs.scanBoxRef.focus()
          })
      }
      else
      {
        
        let newBoxList = this.boxList.map((item) => {
        if (item.customerBox == this.scanBoxNo) {
          this.tableData.push(item);
          flag = false;
          return {};
        } else {
          return item;
        }
        });
        if (flag) {
          this.showNoMatch = true;
        } else {
          this.showNoMatch = false;
          this.isShowScanNoSend=true;//存在未发
        }
        this.boxList = newBoxList;
        this.scanBoxDisabled = false
        this.$nextTick(()=>{
          this.$refs.scanBoxRef.focus()
        })

        // 根据出库单号缓存已扫描箱号
        let scannedBoxNumber = this.tableData.map(item => item.customerBox)
        window.localStorage.setItem(this.outboundNo,JSON.stringify(scannedBoxNumber))
      }
      
    },
   callFunction(item) {
      this[item.func].apply(this, item);
    },
    handleRowSelect(rows) {
      this.selectRows = rows;
    },
    handleRowClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    //查询
    initTable() {
      if (this.outboundNo === "" || this.outboundNo === null) {
        this.$message({
          message: "出库单号不能为空！",
          type: "error",
        });

        return;
      }
      this.shartSearch = true;
       const para = {
        outboundNo: this.outboundNo,
        isContainBox:true,
      };
      this.$refs.outboundRef.select()
      getOutboundSendDetail(para).then((res) => {
        this.shartSearch = false;
        console.info(res);
        if (res.data.response) {
          this.OutboundInfo = res.data.response;
          this.boxList = res.data.response.boxList;
          this.tableData = []
          this.isShowScanNoSend=false;//初始化为全部发货
          // 托打列表
          this.trayTableData = res.data.response.palletList || []

          //  根据单号获取缓存箱号
          let storagesNmuber = window.localStorage.getItem(this.outboundNo)
          if(storagesNmuber){
            let newBoxList = this.boxList.map((item) => {
              if (JSON.parse(storagesNmuber).includes(item.customerBox)) {
                this.tableData.push(item);
                return {}
              } else {
                return item;
              }
            })
            this.boxList = newBoxList;
          }
        } else {
          this.trayTableData = []
          this.OutboundInfo = {};
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    close() {
      this.clearImgModel();
      this.showPhotoModel = false;
    },
    //确认发货
    passLoadingReview() {
       if (this.outboundNo === "" || this.outboundNo === null) {
        this.$message({
          message: "出库单号不能为空！",
          type: "error",
        });
        return;
       };
        if (this.OutboundInfo.outboundNo=== undefined) {
        this.$message({
          message: "请扫描单号后再操作！",
          type: "error",
        });
        return;
       };
      if (!this.storages.length && this.isShowScanNoSend) {
        this.$message({
          message: "请选择库位",
          type: "error",
        });
        return;
      }
      if (!this.tableData.length && this.isShowScanNoSend) {
        this.$message({
          message: "请扫描箱号",
          type: "error",
        });
        return;
      }
      this.showPhotoModel = true;
      this.saveImgUrlArr = [];
      let NoBoxIDsArr = this.tableData.map((item) => item.tfDeliveryBoxInfoID);
      this.num2s= NoBoxIDsArr.length;
      this.num1s=this.OutboundInfo.boxCount-NoBoxIDsArr.length;
    },

    //导出
    exportBox() {
      let pata = { TFOutboundID: this.OutboundInfo.tfOutboundID };
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(exportTFOutboundBox, {
          params: pata,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //弹出导入文件框
    importBox() {
      const that = this;

      if (!this.OutboundInfo.tfOutboundID ) {
        this.$message({
          message: "请先查询出库单",
          type: "error",
        });
        return;
      }
      this.Importtext = "";
      this.importVisible = true;
      
    },
    //文件上传前验证
     onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }
      return extension || extension2;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },

     //上传文件
     UploadExcel(param) {
      if (param == undefined) {
        this.$message({
          message: "请上传导入文件",
          type: "error",
        });
        return;
      }
      
      this.parafile = param;
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url: importTFOutboundBox + "?tfOutboundID=" + this.OutboundInfo.tfOutboundID,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.type = 1;
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
             this.tableData = res.data.response;
              this.parafile = "";
              param.onError(); // 上传成功的文件会显示绿色的对勾
              this.importVisible = false;
              if(res.data.response.length>0){
                  this.tableData=res.data.response;
                  this.isShowScanNoSend=true;
              }
              else
              {
                this.isShowScanNoSend=false;
              }
              
              this.$message({
                message: res.data.msg,
                type: "success",
              });
             
            
          } else {
            
              this.$message({
                message: res.data.msg,
                type: "error",
              });
              param.onError();
            
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },

     clearImgModel() {
      this.imgObj = {
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      };

      this.saveImgUrlArr = [];
    },
    imgMouseOver(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", true);
    },

    imgMouseLeave(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", false);
    },
    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        const m = type.split("")[3];
        if (m == item.imageType) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    showImg(base64Url) {
      this.dialogVisible = true;
      this.dialogImageUrl = base64Url;
    },

    changeImg(i, i2) {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.toUpload(i, i2);
    },
    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(that.imgObj, `img${that.currentImg}`, e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },
    chooseImage(num) {
      console.log("num=", num);
      this.currentImg = num;
      document.getElementsByClassName("img")[0].value = "";
      document.getElementsByClassName("img")[0].click();
    },

    toUpload(i, i2) {
      const that = this;
      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      const s = this.currentImg;
      this.$set(this.photoList[i][i2], "loading", true);
      this.uploadImgIng = true
      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        this.uploadImgIng = false
        this.$set(this.photoList[i][i2], "loading", false);
        if (res.data.status === 200 && res.data.success) {
          console.log("this.currentImg=", this.currentImg);
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            imageType: s,
          });
          this.imgFiles = [];
          if(this.clickSubmit){
            this.$nextTick(()=>{
              this.clickSubmit = false
              this.submit()
            })
          }
        } else {
          this.$message({
            message: "图片上传失败，请重试",
            type: "error",
          });
        }
      });
    },
    receiptTo(){
      const { query } = this.$route 
      if(query.outboundNo && query.outboundNo !== this.outboundNo) {
        this.outboundNo = query.outboundNo
        this.$nextTick(()=>{
          this.initTable()
        })
      }
    },
    submit() {
      // 图片正在上传中
      let loading
      if(this.uploadImgIng){
        this.clickSubmit = true
        this.loading = this.$loading({
          lock: true,
          text: "操作中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)",
        })
        return
      } else if(this.loading){
        this.loading.close();
      }

      if (!this.saveImgUrlArr.length) {
        this.$message({
          message: "请上传带*号的必填图片",
          type: "error",
        });
        return;
      }

      let flag = false;
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          let arr = [];
          this.saveImgUrlArr.forEach((item3, i) => {
            arr.push(item3.imageType);
          });
          if (item2.required && !arr.includes(item2.id)) {
            flag = true;
          }
        });
      });
      if (flag) {
        this.$message({
          message: "请上传带*号的必填图片",
          type: "error",
        });
        return;
      }
      let NoBoxIDsArr = this.tableData.map((item) => item.tfDeliveryBoxInfoID);
      console.info(NoBoxIDsArr);
      const data = {
        TFOutboundID: this.OutboundInfo.tfOutboundID,
        Storages: this.storages.join(','), //  库位
        NoBoxIDs: NoBoxIDsArr.join(','), // 已扫码箱号
        imageUrls: this.saveImgUrlArr,
      };

      loading = this.$loading({
        lock: true,
        text: "操作中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      overSendSubmit(data).then((res) => {
        this.clickSubmit = false
        loading.close();
        if (res.status === 200 && res.success) {
          // 装车成功移除箱号缓存
          window.localStorage.removeItem(this.outboundNo)
          this.$message({
            message: res.msg,
            type: "success",
          });

          this.clearImgModel();
          this.close();
          this.$emit("cancelDalog", "");
          this.$emit('searchTable','')
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  watch:{
    $route(to,from){
      this.receiptTo()
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.receiptTo()
  },
};
</script>

<style scoped lang="less">
.left-item {
  float: left;
  width: 24%;
  // min-width: 285px;
}
.left-item-card {
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}
.outboundNoItem{
  display: flex;
  margin-bottom: 0;
  ::v-deep .el-form-item__content{
    flex: 1;
  }
}
.buttonDiv {
  ::v-deep .el-form--inline .el-form-item{
    margin-bottom: 0;
  }
}
.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}

.boxRow {
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  padding: 15px 10px;
  margin: 10px 0;
  .boxLastRow {
    display: flex;
    .removeLink {
      margin-right: 10px;
      white-space: nowrap;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .boxFirstRow {
    .el-input {
      margin-right: 2px;
    }
  }
}
.noMarginBot {
  margin-bottom: 10px;
}
 
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
.addLink {
  align-self: flex-end;
  padding-bottom: 10px;
  white-space: nowrap;
  margin-left: 10px;
}
.errorMsg {
  color: red;
  text-align: center;
  width: 50%;
}
.image-box {
  float: left;
  width: 20%;
  text-align: center;
}
.sign-photo-btn {
  width: 100px;
  border: 1px dashed #ccc;
  margin: 0 auto;
  height: 100px;
  cursor: pointer;
}
.sign-photo-btn:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.sign-photo-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.photo-s {
  color: #bfbfbf;
  padding: 23px 0;
  margin: 0;
  i {
    font-size: 55px;
  }
}
.sign-photo-item {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  position: relative;
  img {
    height: 100px;
    width: 100px;
  }
}
.del-box {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    cursor: pointer;
    color: rgb(248, 248, 248);
    margin-top: 35px;
  }
}
.loading-box {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    color: rgb(224, 222, 222);
    margin-top: 35px;
  }
}
.hidden {
  display: none;
}
.demo-image {
  max-height: 500px;
  overflow: auto;
  > ul {
    display: flex;
    justify-content: space-around;
  }
}

.imgPreview {
  height: 50%;
  margin-top: 0 !important;
  height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
}
.imgPreview .el-dialog__body {
  height: calc(100% - 85px);
  text-align: center;
}
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>